import * as React from 'react';
import {
  PictogramBuildingCommissioning40,
  PictogramBuildingClass40,
  PictogramBuildingBuilding40,
  PictogramBuildingBuildingType40,
  PictogramBuildingFloor40,
  PictogramBuildingHeight40,
  PictogramBuildingParking40,
  PictogramBuildingRenovation40,
} from '@cian/ui-kit-design-tokens/pictograms';
import { EItemType } from '../types/newbuilding/specification';

export const SPECIFICATIONS_ICON_MAP: { [id: string]: React.ReactNode } = {
  [EItemType.FinishDate]: <PictogramBuildingCommissioning40 />,
  [EItemType.NewbuildingClass]: <PictogramBuildingClass40 />,
  [EItemType.Floors]: <PictogramBuildingFloor40 />,
  [EItemType.Houses]: <PictogramBuildingBuilding40 />,
  [EItemType.MaterialType]: <PictogramBuildingBuildingType40 />,
  [EItemType.CeilingHeight]: <PictogramBuildingHeight40 />,
  [EItemType.Decorations]: <PictogramBuildingRenovation40 />,
  [EItemType.Parking]: <PictogramBuildingParking40 />,
  [EItemType.ResidentialStatus]: <PictogramBuildingBuilding40 />,
};
